import "core-js/modules/es.string.anchor";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
var useStyles = makeStyles(function () {
  return (
    /* theme */
    {
      root: {},
      anchor: {}
    }
  );
}, {
  name: 'SxComAnchorContainer'
});
var AnchorContainer = /*#__PURE__*/React.forwardRef(function AnchorContainer(_ref, ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      renderToAnchor = _ref.renderToAnchor,
      rest = _objectWithoutProperties(_ref, ["children", "classes", "className", "renderToAnchor"]);

  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className),
    ref: ref
  }), /*#__PURE__*/React.createElement("a", {
    className: classes.anchor,
    name: renderToAnchor
  }, ''), children);
});
AnchorContainer.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.shape({
    anchor: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  renderToAnchor: PropTypes.string
};
AnchorContainer.defaultProps = {
  children: undefined,
  classes: undefined,
  className: undefined,
  renderToAnchor: 'parameters'
};
export default AnchorContainer;